export const HONEY_BADDGER_API_KEY = "edb0fd5a";
export const AUTH_USER_POOL_ID = "us-east-1_XvEIjtaRZ";
// export const AUTH_AUD = "4nq0dgcqm6q5oksu6huu8ikpbe";
export const AUTH_AUD = "464shpecbev68hvv8h0f6gg9kg";
export const AUTH_BASE_URL = "https://cognito-idp.us-east-1.amazonaws.com/";
export const AUTH_DOMAIN = "auth.dabaone.com";
// export const AUTH_BASE_URL = "https://" + AUTH_DOMAIN + "/";
export const AUTH_ISS = AUTH_BASE_URL + AUTH_USER_POOL_ID;
export const SIGNALWIRE_PROJECT_ID = "93d6fc48-f48b-406d-8c54-3ebcbd41ddbc";

export const API_BASE_URL = window.location.host.includes("app")
  ? "https://api.dabaone.com"
  : `http://${window.location.hostname}:3031`;
export const WEB_BASE_URL = window.location.host.includes("app")
  ? "https://app.dabaone.com"
  : `http://${window.location.hostname}:8080`;
export const ENVIRONMENT_NAME = window.location.host.includes("app")
  ? "prod"
  : "dev";
export const FETCH_LIMIT = 10000;
export const POLL_IN_SECONDS = 6000000;
export const RENEW_TOKEN_BEFORE_IN_SECONDS = 120;
//export const RENEW_TOKEN_BEFORE_IN_SECONDS = 3500;
export const STRIPE_PUBLIC_API_KEY = window.location.host.includes("app")
  ? "pk_WQt2u9PPzv7B3aftlJwFYa3sOpgmx"
  : "pk_JkV7vadk9ufhqa12BVjNO5LuS17SN";
// export const STRIPE_PUBLIC_API_KEY = "pk_JkV7vadk9ufhqa12BVjNO5LuS17SN"; // test
// export const STRIPE_PUBLIC_API_KEY = "pk_WQt2u9PPzv7B3aftlJwFYa3sOpgmx"; // prod
export const MARKETING_WEBSITE_PLAN_URL = "https://www.dabacall.com/pricing/";
export const SUBSCRIPTION_PLANS = [
  "daba_basic_sub_mon",
  "daba_basic_sub_yr",
  "daba_stand_sub_mon",
  "daba_stand_sub_yr",
  "daba_pro_sub_mon",
  "daba_pro_sub_yr"
];

export const CUSTOMER_SEARCH_FUSE_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  findAllMatches: true,
  //includeScore: true,
  //includeMatches: true,
  threshold: 0.5,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["name", "phone.number"]
};
export const USER_ROLES = [
  { label: "Chat Agent", code: "chatAgent", value: 1 },
  { label: "Service Employee", code: "serviceEmployee", value: 2 }
];
export const USER_AUTH_ROLES = [
  { label: "No Access", value: 1 },
  { label: "Admin", value: 2 },
  { label: "User", value: 3 }
];
export const REPLACE_WITH_REVIEW_LINK = "{{REQUEST_REVIEW_LINK}}";
export const REVIEW_REQUEST_DOMAIN = "https://2rvw.us/";
export const TELECOM_INBOUND_CALL_METHODS = [
  { label: "Dial number(s)", value: "forward" },
  { label: "Send to hold queue", value: "queue" }
];

// Not needed yet
export const NEW_CUSTOMER_FIELDS = [
  { label: "Source", value: "source" },
  { label: "Phone Number", value: "phone" },
  { label: "Address", value: "address" }
];
export const CALENDAR_WORKDAY_OPTIONS = [
  { label: "Sunday", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 }
];
export const CALENDAR_APPOINTMENT_FIELDS = [
  { label: "Customer", value: "customer" },
  { label: "Address", value: "address" },
  { label: "Contact Info", value: "contactInfo" },
  { label: "Service Employee", value: "serviceEmployee" },
  { label: "Job Type", value: "jobType" },
  { label: "Note", value: "note" }
];
